import React, { useRef } from 'react';
import { SelectionRadioListItem } from 'modules/ai/nba/components/selectionListWithRadio/SelectionRadioListItem';
import { StyledRadioList } from 'modules/ai/nba/components/selectionListWithRadio/SelectionRadioList.styles';
import { RecommendedSuggestionCardContent } from 'modules/ai/nba/components/recommendedContents/RecommendedSuggestionCardContent';

interface SelectionRadioListProps<RecommendationT extends RadioListItemChildrenComponent> {
  setSelectedValues: (param: string) => void;
  selectedValue: string;
  recommendations: Array<RecommendationT>;
  RadioListItemComponent?: React.FC<React.PropsWithChildren<RadioListItemChildrenComponent>>;
}

interface RadioListItemChildrenComponent {
  id?: string;
  [key: string]: any;
}

export const SelectionRadioList = <RecommendationT extends RadioListItemChildrenComponent>({
  setSelectedValues,
  recommendations,
  selectedValue,
  RadioListItemComponent = RecommendedSuggestionCardContent,
}: SelectionRadioListProps<RecommendationT>) => {
  const lastRecommendationItemRef = useRef<HTMLDivElement>(null);

  const recs = recommendations?.map((item: any, index) => {
    let RadioListItemRef = null;
    // setting the ref to be the last recommendation item, scroll to last item when clicked in see more
    if (index === recommendations.length - 1) {
      RadioListItemRef = lastRecommendationItemRef;
    }

    return (
      <SelectionRadioListItem
        ref={RadioListItemRef}
        key={`${index}-radio-item`}
        id={`${index}`}
        setSelectedValue={setSelectedValues}
        selectedValue={selectedValue}
        isRadioSelectionEnabled={recommendations.length > 1}
      >
        <RadioListItemComponent {...item} />
      </SelectionRadioListItem>
    );
  });

  return <StyledRadioList data-test="recommendation-list">{recs}</StyledRadioList>;
};
